import React from 'react';
import { styles } from "./styles";
import { CloseIcon } from './CloseIcon';
export function GridNotificationBox(props) {
    return (React.createElement("div", { className: styles.notification },
        React.createElement("div", { className: styles.notificationContent }, props.content),
        !!props.hasClose && (React.createElement("button", { onClick: props.onRequestClose, className: styles.notificationClose },
            React.createElement(CloseIcon, null)))));
}
//# sourceMappingURL=GridNotificationBox.js.map